import { Container } from "@mui/system";
import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import VideoFeaturedButtonsCustom from "./VideoFeaturedButtonCustoms";
import {
  concatDownloadPath,
  concatHostAndImagePath,
} from "../../../lib/functions/utils.lib";

const CustomVideoPlayer = ({ data }) => {
  console.warn("data", data);
  const [videoState, setVideoState] = useState({
    playing: false,
    muted: false,
    volume: 0.5,
    seeking: false,
    Buffer: false,
    loaded: 0,
    loadedSeconds: 1,
    played: 0,
    playedSeconds: 0,
  });

  const playPauseHandler = () => {
    //plays and pause the video (toggling)
    setVideoState({ ...videoState, playing: !videoState.playing });
  };
  const handleChangeSlider = (val) => {
    let v = val / 100;
    // console.warn("v", v);
    // console.warn("t", v* (videoState.loadedSeconds / videoState.loaded));
    //plays and pause the video (toggling)
    setVideoState({ ...videoState, played: val / 100 });
    // console.warn(
    //   "videoPlayerRef.current.getCurrentTime(",
    //   videoPlayerRef.current.getCurrentTime()
    // );
    videoPlayerRef.current.seekTo(
      v * (videoState.loadedSeconds / videoState.loaded)
    );
  };
  const resetVideoHandler = () => {
    //plays and pause the video (toggling)
    setVideoState({ ...videoState, playing: false });
  };
  const muteHandler = () => {
    //plays and pause the video (toggling)
    setVideoState({ ...videoState, muted: !videoState.muted });
  };
  const videoPlayerRef = useRef(null);
  // const containerRef = useRef(null);

  const fastFowardHandler = () => {
    //FastFowards the video player by adding 10
    videoPlayerRef.current.seekTo(videoPlayerRef.current.getCurrentTime() + 10);
  };

  const handleBuffer = (val) => {
    setVideoState({ ...videoState, Buffer: val });
  };

  const containerRef = useRef(null);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }
    containerRef.current
      .requestFullscreen()
      .catch((err) => console.warn("err", err));
    return;
  };

  const onchangebitrate = (event) => {
    const internalplayer = videoPlayerRef.current?.getInternalPlayer("hls");
    if (internalplayer) {
      // currentlevel expect to receive an index of the levels array
      internalplayer.currentlevel = event.target.value;
    }
  };
  return (
    <Container maxWidth="md" justify="center">
      <div ref={containerRef} className="player__wrapper">
        <ReactPlayer
          ref={videoPlayerRef}
          onProgress={(val) => {
            // console.warn("val", val);
            setVideoState({ ...videoState, ...val });
          }}
          className="player"
          url={concatHostAndImagePath(data?.video.video)}
          width="100%"
          height="100%"
          playing={videoState.playing}
          muted={videoState.muted}
          onEnded={resetVideoHandler}
          onBuffer={() => handleBuffer(true)}
          onBufferEnd={() => handleBuffer(false)}
        />
        {videoState.Buffer && <h1>Buffring...............</h1>}
        <VideoFeaturedButtonsCustom
          videoControl={{
            videoState,
            playPauseHandler,
            fastFowardHandler,
            muteHandler,
            toggleFullscreen,
            handleChangeSlider,
          }}
        />
        quality:
        <select onchange={onchangebitrate}>
          {videoPlayerRef?.current
            ?.getInternalPlayer("hls")
            ?.levels?.map((level, id) => (
              <option key={id} value={id}>
                {level.bitrate}
              </option>
            ))}
        </select>
      </div>
    </Container>
  );
};

export default CustomVideoPlayer;
